import React from "react";
import { NavLink } from "react-router-dom";
import { 
  FaHome, 
  FaUsers, 
  FaUserTie, 
  FaBriefcase, 
  FaCheckCircle,
  FaClipboardList,
  FaFolder,
  FaKey,
  FaDollarSign,
  FaCog
} from "react-icons/fa";
import { MdPersonSearch } from "react-icons/md";
import "../../../asset/new/css/admin-modern.css";

const AdminSideBar = ({ isOpen = false, onClose = () => {} }) => {

  const navItems = [
    {
      path: "/admin/dashboard",
      icon: <FaHome />,
      label: "Dashboard"
    },
    {
      path: "/admin/profile",
      icon: <FaUserTie />,
      label: "My Profile"
    },
    {
      path: "/admin/jobSeekerList",
      icon: <FaUsers />,
      label: "Job Seekers"
    },
    {
      path: "/admin/employerList",
      icon: <FaBriefcase />,
      label: "Employers"
    },
    {
      path: "/admin/postjob",
      icon: <FaClipboardList />,
      label: "Post Job"
    },
    {
      path: "/admin/approveJobs",
      icon: <FaCheckCircle />,
      label: "Approve Jobs"
    },
    {
      path: "/admin/postedjobs",
      icon: <FaBriefcase />,
      label: "Posted Jobs"
    },
    {
      path: "/admin/folder",
      icon: <FaFolder />,
      label: "Manage Folders"
    },
    {
      path: "/admin/candidateSearch",
      icon: <MdPersonSearch />,
      label: "Candidate Search"
    },
    {
      path: "/admin/addaccess",
      icon: <FaKey />,
      label: "Add Access"
    },
    {
      path: "/admin/packageSalesHistory",
      icon: <FaDollarSign />,
      label: "Package Sales"
    },
    {
      path: "/admin/master-settings",
      icon: <FaCog />,
      label: "Master Settings"
    }
  ];

  const handleLinkClick = () => {
    if (window.innerWidth < 1024) {
      onClose?.();
    }
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="d-lg-none"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.5)',
            zIndex: 998
          }}
          onClick={onClose}
        />
      )}

      <aside className={`admin-sidebar ${isOpen ? 'active' : ''}`}>
        <div className="admin-sidebar-content">
          {/* Main Navigation */}
          <div className="admin-sidebar-section">
            <div className="admin-sidebar-section-title">Main Menu</div>
            <nav className="admin-sidebar-nav">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  className={({ isActive }) =>
                    isActive ? "admin-sidebar-link active" : "admin-sidebar-link"
                  }
                  onClick={handleLinkClick}
                >
                  <div className="admin-sidebar-link-icon">{item.icon}</div>
                  <span className="admin-sidebar-link-text">{item.label}</span>
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSideBar;
